exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".items {\n  padding: 0.2rem;\n  position: relative;\n  border-radius: 0.5rem;\n  background: #fff;\n  color: rgba(0, 0, 0, 0.8);\n  overflow: hidden;\n  font-size: 0.9rem;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0px 10px 20px rgba(0, 0, 0, 0.1);\n}\n.item {\n  display: block;\n  margin: 0;\n  width: 100%;\n  text-align: left;\n  background: transparent;\n  border-radius: 0.3rem;\n  border: 1px solid transparent;\n  padding: 0.3rem 0.4rem;\n}\n.item.is-selected {\n    border-color: rgba(0, 0, 0, 0.35);\n}\n", ""]);

// exports
